import React from 'react';
import PropTypes from 'prop-types';

import TableSectionContext from './TableSectionContext';

const TableBody = ({ children }) => {
  return (
    <TableSectionContext.Provider value="body">
      <tbody>{children}</tbody>
    </TableSectionContext.Provider>
  );
};

TableBody.propTypes = {
  children: PropTypes.node
};

TableBody.defaultProps = {
  children: undefined
};

export default TableBody;
